<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CampaignReportsAPI from 'dashboard/api/campaignReports';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

const { t } = useI18n();

const ssoUrl = ref('');
const isLoading = ref(true);
const errorMessage = ref('');

const fetchSsoUrl = async () => {
  isLoading.value = true;
  errorMessage.value = '';
  try {
    const { data } = await CampaignReportsAPI.ssoUrl();
    ssoUrl.value = data.url;
  } catch (error) {
    errorMessage.value =
      error?.response?.data?.error || t('CAMPAIGNS_REPORTS.NOT_CONFIGURED');
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchSsoUrl);
</script>

<template>
  <!-- Rendered inside ReportsWrapper's fullBleed slot (see reports.routes.js meta.fullBleed +
       ReportsWrapper.vue). No header/title/border here on purpose — the embedded app has its
       own top nav (TopNavLayout on the reports-metaads side), so this is just the iframe,
       edge-to-edge, filling the whole panel. -->
  <div class="flex flex-col flex-1 min-h-0">
    <LoadingState
      v-if="isLoading"
      :message="t('CAMPAIGNS_REPORTS.LOADING_MESSAGE')"
    />
    <div
      v-else-if="errorMessage"
      class="flex items-center justify-center flex-1 p-8"
    >
      <p class="text-body-main text-n-slate-11 text-center max-w-md">
        {{ errorMessage }}
      </p>
    </div>
    <iframe
      v-else
      :src="ssoUrl"
      :title="t('CAMPAIGNS_REPORTS.HEADER')"
      class="w-full flex-1 min-h-0 border-0"
    />
  </div>
</template>
